import { AnalyticsBrowser } from '@segment/analytics-next'
import { appConfig } from 'src/config/app.config'
import { FiltersValue, SkillType } from './types/expert.types'
import { UserProfile } from './types/auth.types'

export default class SegmentAnalytics {
    private static analytics: AnalyticsBrowser
    private static profile: UserProfile | null = null
    private static initialEventData: object = {}

    static setInitialData(profile: UserProfile) {
        this.analytics = AnalyticsBrowser.load({ writeKey: appConfig.segmentAPIKey })
        this.profile = profile
    }

    private static resetInitialEventData(): void {
        this.initialEventData = {}
    }

    private static shouldTrackEvent(filterKey?: string): boolean {
        return (
            (filterKey !== FiltersValue.Language && filterKey !== SkillType.Level) ||
            Object.keys(this.initialEventData).length > 0
        )
    }

    static sendTrackEvent(eventName: string, eventParams: object, filterKey?: string): void {
        if (this.shouldTrackEvent(filterKey)) {
            this.analytics?.track(eventName, {
                userId: this.profile?.user_id,
                ...this.initialEventData,
                ...eventParams,
            })
            this.resetInitialEventData()
        }
    }

    static appendEventData(eventParams: object): void {
        this.initialEventData = {
            ...this.initialEventData,
            ...eventParams,
        }
    }
}
